
/********* Script_Details ************
 * @Original_Creator :- Munnaf Hossain Mondal.
 * @Created_Date :- 02-06-2023.
 * @Last_Update_By :- Munnaf Hossain Mondal.
 * @Last_Updatd_Date :- 02-06-2023.
 * @Description :- This class used for remote API Calls(REST).
 ************************************/

//#region - Class defination 
export default class Service {
    /**
     * Create class instance and fill params from URL or fill it with default values if URL not contain needed data.
     * @constructs
    */
    constructor() {
        //================Platform API URL================================
        // this.baseUrl = "http://localhost:5000/api/v1/";//New structure
        this.baseUrl = "https://api.ralbatech.com/api/v1/";//New structure

        //================================================================

    };

    /**
     * Requests data from Service, and call handler function after responce was received. URL contain only
     * needed data - action name and it's params. Static parts or URL stored in class instance.
     * @public
     * @param {string} url - string with action name and params.
     * @param {function} callback - function that will be called with responce as param.
     * @returns {object} response in json format.
    **
    ****/
    async getData(url, options) {
        try {
            let response = await fetch(url, options);
            if (response.status == 200) {
                return response.json();
            } else {
            }
        } catch (err) {
            console.log("getData Error log: ", err);
        }
    };


    /***
     * Recieves 3d product list data
     * @public
     * @param {string} vendor_id - vendor_id
     * @returns {object} 3d product list data with sucess 
    ***/
    async storeDetails(store_slugs) {
        try {
            let option = {
                store_slug: store_slugs
            }
            let url = this.baseUrl + "stores/details"
            return (await window.securityService.signedRequest('POST', url, option));
        } catch (err) {
            console.log("storeDetails Error: ", err);
        }
    };

        /***
     * Recieves 3d product list with thoes not assign on store data
     * @public
     * @param {string} vendor_id - vendor_id
     * @returns {object} 3d product list data with sucess 
    ***/

    async get3dProductList(vendor_id) {
        try {
            let option = {
                vendor_id: vendor_id
            }
            let url = this.baseUrl + "stores/product-3d-list-by-vendor"
            return (await window.securityService.signedRequest('POST', url, option));
        } catch (err) {
            console.log("get3dProductList Error: ", err);
        }
    };
        /***
     * Recieves 3d product list by vendor
     * @public
     * @param {string} vendor_id - vendor_id
     * @returns {object} 3d product list data with sucess 
    ***/

    async all3dProductListByVendor(vendor_id) {
        try {
            let option = {
                vendor_id: vendor_id
            }
            let url = this.baseUrl + "stores/all-product-3d-list-by-vendor"
            return (await window.securityService.signedRequest('POST', url, option));
        } catch (err) {
            console.log("get3dProductList Error: ", err);
        }
    };


    /***
     * Recieves 3d product list data
     * @public
     * @param {string} vendor_id - vendor_id
     * @returns {object} 3d product list data with sucess 
    ***/

           async productplace3droom(store_no,store_slug,product_sku,product_codination) {
            try {
                let option = {
                    store_no: String(store_no),
                    store_slug: store_slug,
                    product_sku: product_sku,
                    product_codination: product_codination
                }
                console.log('option productplace3droom',option);
                let url = this.baseUrl + "vender/store/product-update"
                return (await window.securityService.signedRequest('POST', url, option));
            } catch (err) {
                console.log("get3dProductList Error: ", err);
            }
        };
}
